'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../../libs/colors');

exports.default = {
  railStyle: {
    background: _colors.grey
  },
  trackStyle: {
    background: _colors.red
  },
  handleStyle: {
    borderColor: _colors.red
  }
};